<div id="main_theme_id_class" style="display: inline" [class]="appService.theme">
  <mat-progress-bar style="z-index: 999999; position:absolute;" *ngIf="loader.isLoading | async" mode="indeterminate">
  </mat-progress-bar>
<!--
  <mat-progress-bar style="z-index: 1;position:absolute" *ngIf="http.loadingProgress"
      mode="determinate" [value]="http.percentageDone"></mat-progress-bar>
-->
  <router-outlet></router-outlet>
</div>